import Socket from '../connection/socket';
import * as ChatActions from '../stores/actions/chat';
import { ChatRoom } from '../stores/reducers/chat';
import { GreenroomState } from '../stores/types/types';
import { getState, socketListenerDispatch } from './socket-listener-main';

function handleNewRoom(room: ChatRoom) {
	const {
		SessionReducer: {
			user,
		},
	} = getState();

	if (room.participants.includes(user.gr_user)) {
		socketListenerDispatch(ChatActions.newRoom(room));
	}
}

function handleChatMessage(message: any) {
	const {
		SessionReducer: {
			user,
			activeTab,
		},
	} = getState();

	socketListenerDispatch(ChatActions.newMessage({ ...message, openTab: activeTab }));
}

function handleChatReload(message: any) {
	const {
		SessionReducer: {
			token,
			meeting,
			user,
		},
	} = getState();

	if (message?.user !== user.gr_user) {
		socketListenerDispatch(ChatActions.loadRoomChat(token, meeting.meeting));
	}
	socketListenerDispatch(ChatActions.clearChatDirectChat());
	socketListenerDispatch(ChatActions.loadChatPosts(token, meeting.meeting));
}

function handleRemoveMessage(
	message: {
		message: {
			from: string | null,
			messageId: number,
			roomId: number | undefined,
			dmKey: string,
		}
	},
) {
	const { SessionReducer: { session } } = getState() as GreenroomState;

	const {
		from,
		messageId,
		roomId,
		dmKey,
	} = message.message;

	if (from !== session) {
		socketListenerDispatch(ChatActions.removeChatMessage(messageId, roomId, dmKey));
	}
}

export default function Chat(socket: Socket) {
	const {
		SessionReducer: {
			embed,
		},
	} = getState();

	if (!embed) {
		socket.addListener('chat-message', handleChatMessage);
		socket.addListener('new-room', handleNewRoom);
		socket.addListener('reload-chat', handleChatReload);
		socket.addListener('remove-chat-message', handleRemoveMessage);
	}
}
